
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Slider from "./slider/Slider";
import ServiceSection from "./service/ServiceSection";
import BlogSection from "./blog/BlogSection";
import PortfolioSection from "./portfolio/PortfolioSection";
import AboutSection from "./about/AboutSection";
import ConsultationSection from "./consultation/ConsultationSection";
import styles from './Main.module.css';
import Icon from '../design-system/General/Icon';

const text = 'UNIXA';
const API_BASE = `${window.location.origin}/wp-json/acf/v3`;
const templateUrl = `${window.location.origin}/wp-content/themes/unixa`;
export default function Main() {
    const myShowcase = useRef(null);
    const infoRef = useRef(null);
    const footerRef= useRef(null)
    const [data, setData] = useState(null);
    const bgTextRef = useRef(null);
    const [angle, setAngle] = useState(0);
    const [activeIndex, setActiveIndex] = useState(1); 
    const [prevIndex, setPrevIndex] = useState(2);  
    const [showIndexes, setShowIndexes] = useState([]);
    const [locked, setLocked] = useState(false);
    const [displayIndex, setDisplayIndex] = useState(1); 

    const aboutRef = useRef(null);
    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const blogRef = useRef(null);
    const consultRef = useRef(null);

    const [footerButtonText, setFooterButtonText] = useState("نمونه کارها");
    const [footerButtonLink, setFooterButtonLink] = useState("/portfolios");

    const sectionRefs = [aboutRef, serviceRef, portfolioRef, blogRef, consultRef];


    useEffect(() => {
        fetch(`${API_BASE}/homepage`)
        .then(res => res.json())
        .then(json => setData(json))
        .catch(err => console.error(err));
    }, []);

     const [options, setOptions] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/theme-options`)
        .then(res => res.json())
        .then(data => {
            setOptions(data);
        })
        .catch(err => console.error(err));
    }, []);

    const images = data?.image_slider || [];
    const sliderData = data?.add_slider || [];
    
    useEffect(() => {
        if (!data || !bgTextRef.current) return;
        const spans = Array.from(
            bgTextRef.current.querySelectorAll(`.${styles['unxw-vs-frame-bg-text-char']}`)
        );

        bgTextRef.current.style.opacity = "1";
        spans.forEach((span) => {
            span.classList.add(styles['unxw-show']);
        });
    }, [displayIndex, data]);

    useEffect(() => {
        text.split("").forEach((_, index) => {
            setTimeout(() => {
                setShowIndexes((prev) => [...prev, index]);
            }, index * 50); 
        });
    }, [text]);

    function animateSpans() {
        if (!bgTextRef.current) return;

        const spans = Array.from(
            bgTextRef.current.querySelectorAll(`.${styles['unxw-vs-frame-bg-text-char']}`)
        );

        spans.forEach((span) => {
            span.classList.remove(styles['unxw-show']);
        });

        setTimeout(() => {
            spans.forEach((span, index) => {
                setTimeout(() => {
                    span.classList.add(styles['unxw-show']);
                }, 70 * index);
            });
        }, 700);
    }
    const nextSlide = () => {
        setPrevIndex(activeIndex);
        setActiveIndex((activeIndex + 1) % images.length);
    };

    function handleSlideChange(swiper) {
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
        setLocked(true);
        
        const currentIndex = swiper.activeIndex + 1;
        
        setAngle(prev => prev + 180);

        animateSpans();

        if(infoRef.current) {
            infoRef.current.classList.add(styles["unxw-vs-frame-animate-out"]);

            setTimeout(() => {
                setDisplayIndex(currentIndex);

                setTimeout(() => {
                    infoRef.current.classList.remove(styles["unxw-vs-frame-animate-out"]);
                    if (currentIndex % 2 === 0) {
                        infoRef.current.classList.add(styles["unxw-vs-frame-even"]);
                        document.body.classList.add("dark");
                    } else {
                        infoRef.current.classList.remove(styles["unxw-vs-frame-even"]);
                        document.body.classList.remove("dark");
                    }
                }, 50);
            }, 700);

            nextSlide();
        }

        if(myShowcase.current) {
            if(currentIndex > 3) {
                myShowcase.current.classList.add(styles["unxw-vs-last-slide"]);
                if (currentIndex % 2 === 0) {
                    footerRef.current.classList.add('dark');
                } else {
                    footerRef.current.classList.remove('dark');
                }
            } else {
                myShowcase.current.classList.remove(styles["unxw-vs-last-slide"]);
                if (currentIndex % 2 === 0) {
                    footerRef.current.classList.remove('dark');
                } else {
                    footerRef.current.classList.add('dark');
                }
            }
        }
    
        sectionRefs.forEach((ref, index) => {
            if (currentIndex > 3) {
                ref.current.classList.remove(styles["active-sec"]);
                if(ref.current && currentIndex - 4 === index ) {
                    ref.current.classList.add(styles["active-sec"]);
                } 
            } else {
                ref.current.classList.remove(styles["active-sec"]);
            }
        });


        if (currentIndex === 4) {
            setFooterButtonText(" درباره ما");
            setFooterButtonLink(data.about_more);
        } else {
            setFooterButtonText("نمونه کارها");
            setFooterButtonLink("/portfolios");
        }

        setTimeout(() => {
            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
            setLocked(false);
        }, 1500);
    }



    useEffect(() => {
        const handleConsultationClick = (e) => {
            const btn = e.target.closest('#consultBtn');

            if (!btn) return;

            e.preventDefault();

            const swiperEl = document.querySelector(
                '[class*="Main_home-swiper"]'
            );

            swiperEl?.swiper?.slideTo(
                swiperEl.swiper.slides.length - 1,
                800
            );
        };

        document.addEventListener('click', handleConsultationClick);

        return () => {
            document.removeEventListener('click', handleConsultationClick);
        };
    }, []);

    useEffect(() => {
        if (window.location.hash === "#consultation") {
            let attempts = 0;
            const maxAttempts = 40; 

            const interval = setInterval(() => {
                attempts++;
                const swiperEl = document.querySelector('[class*="Main_home-swiper"]');

                if (swiperEl?.swiper) {
                    swiperEl.swiper.slideTo(
                        swiperEl.swiper.slides.length - 1,
                        800
                    );
                    window.history.replaceState(null, '', window.location.pathname);
                    clearInterval(interval);
                } else if (attempts >= maxAttempts) {
                    clearInterval(interval);
                }
            }, 250);

            return () => clearInterval(interval);
        }
    }, []);

    if (!data || !options) return null;
    return (
        <div className={styles['unxw-wrapper']}>
            <div className={styles['main-inner']}>
                    <div 
                    className={styles['unxw-vertical-showcase']} 
                    ref={myShowcase}
                    >
                        <div className={styles['unxw-vs-holder']}>
                            <div 
                            className={styles['unxw-vs-stripe']} 
                            style={{transform: `rotate(${angle}deg)`}}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 3000 3000"
                                    xmlSpace="preserve"
                                >
                                    <defs>
                                    <linearGradient
                                        id="SVGID_1_"
                                        gradientUnits="userSpaceOnUse"
                                        x1="1543.491"
                                        y1="1474.8508"
                                        x2="2952.8528"
                                        y2="659.8721"
                                    >
                                        <stop offset="0" stopColor="#340046" />
                                        <stop offset="1" stopColor="#340046" />
                                    </linearGradient>
                                    </defs>
                                    <path
                                    className={styles['st0']}
                                    d="M0,3000h3000V0c0,0-540,0-570.14,0C2071,0,1861.65,130,1500.33,130C1138.55,130,929,0,569.66,0  
                                    C539.99,0,0,0,0,0V3000L0,3000z"
                                    fill="url(#SVGID_1_)"
                                    ></path>
                                </svg>
                            </div>
                            <div className={styles['unxw-vs-frame-holder']}>
                                <div className={styles['unxw-vs-frame-mobile-holder']}>
                                    <img src={`${templateUrl}/assets/images/mobile-frame.png`} alt="Mobile image" />
                                    <div className={styles['unxw-vs-inner-frame']}>
                                        {images.map((img, idx) => {
                                            let className = "";
                                            if (idx === activeIndex) className = styles['active'];
                                            else if (idx === prevIndex) className = styles['prev-active'];

                                            return (
                                            <div key={idx} className={className}>
                                                <img src={img.slider_image} alt={`screen-${idx + 1}`} />
                                            </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div 
                            className={styles['unxw-vs-frame-info']}
                            ref={infoRef}
                            >
                               {sliderData[displayIndex - 1] && (
                                <>
                                    <div className={styles['unxw-vs-frame-info-top']}>
                                        <div>
                                            <div className={styles['unxw-vs-frame-title-image']}>
                                                <img
                                                    width="48"
                                                    height="50"
                                                    src={sliderData[displayIndex - 1].icon}
                                                    alt="icon"
                                                />
                                            </div>

                                            <div
                                            className={styles['unxw-vs-frame-title']}
                                            dangerouslySetInnerHTML={{ __html: sliderData[displayIndex - 1].title }}
                                            />
                                        </div>
                                        <ul className={styles['unxw-vs-frame-info-list']}>
                                            {sliderData[displayIndex - 1].items.map((item, index) => (
                                                <li className={styles['unxw-vs-frame-info-list-item']} key={index}><Icon name={`icon-${item.label_icon}`} />{item.label} </li>
                                            ))}
                                        </ul>
                                        
                                    </div>
                                    <div className={styles['unxw-vs-frame-info-bottom']}>

                                        <div className={styles['unxw-vs-frame-bottom-content']}>
                                            <h3 className={styles['unxw-vs-frame-subtitle']}>
                                                {sliderData[displayIndex - 1].subtitle}
                                            </h3>
                                            <p className={styles['unxw-vs-frame-slide-text']}>
                                                {sliderData[displayIndex - 1].text}
                                            </p>
                                        </div>

                                        <div className={styles['unxw-vs-frame-bg-text']}>
                                            <div className={styles['unxw-vs-frame-bg-text-placeholder']}>UNIXA</div>
                                            <div ref={bgTextRef} className={styles['unxw-vs-frame-bg-text-content']}>
                                                {text.split("").map((char, index) => (
                                                    <span
                                                        key={index}
                                                        className={styles['unxw-vs-frame-bg-text-char']}
                                                    >
                                                        {char}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </> )}

                            </div>
                            <Swiper
                            direction="vertical" 
                            mousewheel={true} 
                            modules={[Pagination, Mousewheel]}
                            slidesPerView={1}
                            pagination={{ clickable: true }}
                            loop={false}
                            style={{ height: 'calc(100vh - 40px)' }}
                            onSlideChange={handleSlideChange}
                            className={`${styles['home-swiper']} ${styles['swiper-container']} ${styles['swiper-container-vertical']}`}
                            >
                                {sliderData && sliderData.map( item => (
                                    <SwiperSlide>
                                        <Slider info={item} />
                                    </SwiperSlide>
                                ))}
                                <SwiperSlide>
                                    <AboutSection sectionRef={aboutRef} title={data.about_title} slogan={data.about_slogan} text={data.about_desc} link={data.about_more} image={data.about_image} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <ServiceSection sectionRef={serviceRef} title={data.service_title} text={data.service_text} services={data.add_services} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <PortfolioSection sectionRef={portfolioRef} title={data.portfolio_title} text={data.portfolio_text} portfolios={data.add_projects} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <BlogSection sectionRef={blogRef} title={data.blog_title} text={data.blog_text} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <ConsultationSection sectionRef={consultRef} title={data.consult_title} text={data.consult_text} consults={data.add_consult} />
                                </SwiperSlide>
                            </Swiper>

                            <div className="footer-sticky">
                                <div className="container-lg">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-auto footer-button">
                                            <a className="theme-button primary" href={footerButtonLink}>
                                                <span class="mas">{footerButtonText}</span>
                                                <span class="btn">{footerButtonText}</span>
                                            </a>
                                        </div>
                                        <div className="col-auto footer-social dark"  ref={footerRef}>
                                            <ul className='d-flex align-items-center justify-content-end'>
                                                <li><a href = {options.whatsapp} target="_blank" rel="noreferrer" className="social-link"><i className='icon-whatsapp'></i></a></li>
                                                <li><a href = {options.telegram} target="_blank" rel="noreferrer" className="social-link"><i className='icon-telegram'></i></a></li>
                                                <li><a href = {options.instagram} target="_blank" rel="noreferrer" className="social-link"><i className='icon-instagram'></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
}